import { call, put, select, takeEvery } from 'redux-saga/effects';
import * as actionTypes from 'constants/actionTypes';
import {
  selectAccountId,
  selectAccountMeta,
  selectAccountMetaMeta,
} from 'reducers/account/meta';
import { promisaga } from 'utils/as-promised';
import * as firebase from 'sagas/firebase/lib';
import {
  FETCH_ACCOUNT_META,
  UPDATE_ACCOUNT_META,
} from 'constants/account/meta';
import {
  replaceAccountMeta,
  setAccountMetaFetching,
  setAccountMetaErrored,
  updateSuccessAccountMeta,
} from 'actions/account/meta';
import { syncFirebasePath } from 'sagas/firebase/internal-lib';
import { showToast } from 'actions/toaster';
import { reportError } from 'helpers/error-reporting';

export function* handleDataReceived(data, accountId) {
  yield put(replaceAccountMeta({ ...data, id: accountId }));
}

export function* fetchAccountMeta(action) {
  const {
    payload: { accountId },
  } = action;

  try {
    const accountMetaMeta = yield select(selectAccountMetaMeta);
    const { fetching, synced, errored } = accountMetaMeta;

    if (errored || (!synced && !fetching)) {
      yield put(setAccountMetaFetching());

      yield call(
        syncFirebasePath,
        `accounts/${accountId}/meta`,
        handleDataReceived,
        actionTypes.CANCEL_ACCOUNT_SYNC,
        accountId
      );
    }
  } catch (error) {
    yield put(setAccountMetaErrored(error));
  }
}

export function* flushAccountMeta({ payload: { changes = {} } }) {
  try {
    const accountId = yield select(selectAccountId);
    const updatedMeta = yield select(selectAccountMeta);

    yield call(firebase.set, `accounts/${accountId}/meta`, updatedMeta);
    if (!changes.lastSeenTimestamp || Object.keys(changes).length > 1) {
      yield put(showToast({ message: 'Account updated', type: 'success' }));
      yield put(updateSuccessAccountMeta());
    }
  } catch (error) {
    yield call(reportError, error);
    yield put(
      showToast({ message: 'Failed to update account', type: 'warning' })
    );
    throw error;
  }
}

export default function* meta() {
  yield takeEvery(FETCH_ACCOUNT_META, fetchAccountMeta);
  yield takeEvery(UPDATE_ACCOUNT_META, promisaga(flushAccountMeta));
}
